import {UrlUtil} from "./url-util";

export class MobileUtil {
    static isTouch() {
        return 'ontouchstart' in document.documentElement || !!(navigator.msMaxTouchPoints);
    }
    
    static isIOS() {
        let userAgent = navigator.userAgent || navigator.vendor || window.opera;
        return userAgent.match( /iPad/i ) || userAgent.match( /iPhone/i ) || userAgent.match( /iPod/i );
    }
    
    static isIphone() {
    	let userAgent = navigator.userAgent || navigator.vendor || window.opera;
    	return userAgent.match( /iPhone/i );
    }
    
    static isIpad() {
    	let userAgent = navigator.userAgent || navigator.vendor || window.opera;
    	return userAgent.match( /iPad/i );
    }

    static isAndroid() {
        let userAgent = navigator.userAgent || navigator.vendor || window.opera;
        return userAgent.match( /Android/i );
    }

    static isMediaQuery(device, range){
        switch(range){
            case Range.UP:
                switch(device){
                    case Device.MOBILE:
                        return window.innerWidth >= 360
                    case Device.SMALL_TABLET:
                        return window.innerWidth >= 568
                    case Device.TABLET:
                        return window.innerWidth >= 768
                    case Device.SMALL_DESKTOP:
                        return window.innerWidth >= 992
                    case Device.DESKTOP:
                        return window.innerWidth >= 1280
                    default:
                        return window.innerWidth >= 1440
                }
            case Range.ONLY:
            default:
                switch(device){
                    case Device.MOBILE:
                        return window.innerWidth < 568
                    case Device.TABLET:
                        return window.innerWidth >= 768 && window.innerWidth < 992
                    case Device.DESKTOP:
                        return window.innerWidth >= 1248 && window.innerWidth < 1440
                }
                break
        }

        return false;
    }

    static isMobile() {
        return this.isMediaQuery(Device.MOBILE, Range.ONLY)
    }

    static isTablet() {
        return this.isMediaQuery(Device.TABLET, Range.ONLY)
    }

    static isDesktop() {
        return this.isMediaQuery(Device.DESKTOP, Range.ONLY)
    }

    static isApp() {
        const app = UrlUtil.queryString("app");
        return app === "ios" || app === "android";
    }
}

export const Device = {
    MOBILE: "mobile",
    SMALL_TABLET: "small-tablet",
    TABLET: "tablet",
    SMALL_DESKTOP: "small-desktop",
    DESKTOP: "desktop",
    BIGGEST: "biggest"
}

export const Range = {
    UP: "up",
    ONLY: "only"
}
